import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class EventService {
  async addNewEvent(params, account_id) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${account_id}/vppevent/submit`,
          MICROSERVICES.VPPMANAGER,
        ),
        params,
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getVppSites(params, account_id, program_id, targetSoc, eventType, startTime, endTime, energyBasedProgram) {
    const eventtype = (eventType === 'Charge Event') ? 'BATTERY_CHARGE' : (eventType === 'Discharge Event') ? 'BATTERY_DISCHARGE' : 'IDLE'
    try {
      const response = energyBasedProgram ?
        await service.put(
          Urls.getApiUrl(
            `admin/${account_id}/vppevent/${program_id}/sites?eventStartDate=${startTime}&eventEndDate=${endTime}&targetSoc=${targetSoc}&eventType=${eventtype}`,
            MICROSERVICES.VPPMANAGER,
          ),
          params,
        ) :
        await service.put(
          Urls.getApiUrl(
            `admin/${account_id}/vppevent/${program_id}/sites`,
            MICROSERVICES.VPPMANAGER,
          ),
          params,
        )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllEventsWithFilter({
    programId,
    accountId,
    eventTime,
    eventSortBy,
    eventSortAscendingOrder,
    eventPageNoAPI,
    eventPageSize,
  }) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/vppevent/all/${programId}?time=${eventTime || ''
      }&sort_by=${eventSortBy || ''}&ascending=${eventSortAscendingOrder
      }&page_no=${eventPageNoAPI || ''}&page_size=${eventPageSize || ''}`,
      MICROSERVICES.VPPMANAGER,
    )
    return await service
      .get(url)
      .then((response) => {
        const { data } = response
        return data.data
      })
      .catch((error) => error)
  }

  async getAllEventsBySiteId(programId, accountId, siteId, time, page, pageSize) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/vppevent/${programId}/${siteId}/all`, MICROSERVICES.VPPMANAGER), {
        params: {
          time: time,
          page_no: page,
          page_size: pageSize
        }
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllEventsCalendarEvents({ programId, accountId, startDate, endDate }) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/vppevent/daterange/all/${programId}`, MICROSERVICES.VPPMANAGER), { params: { input_account_id: accountId, start_date: startDate, end_date: endDate } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllCalendarEventsCount({ programId, accountId, startDate, endDate }) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/vppevent/daterange/count/status/${programId}`, MICROSERVICES.VPPMANAGER), { params: { input_account_id: accountId, start_date: startDate, end_date: endDate } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllEventsByProgramId(programId, accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/vppevent/events/telemetry`, MICROSERVICES.VPPMANAGER), { params: { program_id: programId } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getEventById(accountId, eventId) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${accountId}/vppevent/${eventId}`,
          MICROSERVICES.VPPMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e.data
    }
  }

  async getEventEnergyData(accountId, eventId) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${accountId}/event/${eventId}/energy_graph`,
          MICROSERVICES.TELEMETRYMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e.data
    }
  }

  async cancelEventById(accountId, eventId) {
    try {
      const response = await service.put(
        Urls.getApiUrl(
          `admin/${accountId}/vppevent/cancel/${eventId}`,
          MICROSERVICES.VPPMANAGER,
        ), {},
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystemInEvent(accountId, vppeventId, page, pageSize) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${accountId}/vppevent/${vppeventId}/dispatch-event-list`,
          MICROSERVICES.VPPMANAGER,
        ), {
        params: {
          page_no: page,
          page_size: pageSize
        }
      },
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getEventEnergyPowerData(accountId, eventId) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${accountId}/event/${eventId}/sites_energy_graph`,
          MICROSERVICES.TELEMETRYMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e.data
    }
  }

  async getActiveSites(body, accountId) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${accountId}/active-sites-stats/filter`,
          MICROSERVICES.REPORTMANAGER,
        ),
        body,
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getActiveSitesHistory(accountId, params) {
    try {
      const queryString = Object.entries(params)
        .filter(([, v]) => v != null)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${accountId}/active-sites-stats/active-sites/history?${queryString}`,
          MICROSERVICES.REPORTMANAGER,
        ),
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getAllSiteEvents(body, accountId) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${accountId}/site-event-analysis/filter`,
          MICROSERVICES.REPORTMANAGER,
        ),
        body,
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getDailyDischargeSummary(body, accountId) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${accountId}/site-event-analysis/daily-discharge-summary`,
          MICROSERVICES.REPORTMANAGER,
        ),
        body,
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getYearlyDischargeSummary(body, accountId) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${accountId}/site-event-analysis/yearly-discharge-summary`,
          MICROSERVICES.REPORTMANAGER,
        ),
        body,
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getActiveSiteIds(params) {
    try {
      const queryString = Object.entries(params)
        .filter(([, v]) => v != null && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')
      const response = await service.get(
        Urls.getApiUrl(
          `admin/*/active-sites-stats/active-sites/history/siteIds?${queryString}`,
          MICROSERVICES.REPORTMANAGER,
        ),
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getSiteDailyPerformance(body) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          'admin/*/site-event-analysis/site-daily-performance/filter',
          MICROSERVICES.REPORTMANAGER,
        ),
        body,
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getMonthlyApiHits(params) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          'admin/*/accounts/monthlyHits',
          MICROSERVICES.REPORTMANAGER,
        ),
        { params },
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getDailyApiHits(accountId,inputAccountId, monthKey) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${accountId}/accounts/dailyHits?monthKey=${monthKey}&inputAccountId=${inputAccountId}`,
          MICROSERVICES.REPORTMANAGER,
        ),
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async uploadCSVFile(file, accountId) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${accountId}/site-event-analysis/upload`,
          MICROSERVICES.REPORTMANAGER,
        ),
        formData,
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getSiteEventData(event_id, account_id) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/site-event-analysis/event/${event_id}`,
          MICROSERVICES.REPORTMANAGER,
        ),
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

  async getSiteEventDataBySite(event_id, site_id, account_id) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/site-event-analysis/event/${event_id}/site/${site_id}`,
          MICROSERVICES.REPORTMANAGER,
        ),
      )
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }
}

export const eventService = new EventService()
